import { privateAxios } from "../axiosInstances";
import {
  Conversation,
  ConversationListFilters,
  ConversationSummary,
} from "@ac-expo/api-types";
import conversationKeys from "../query-keys/conversations.query-keys";
import { useQuery } from "@tanstack/react-query";

const getConversationsList = async (filters: ConversationListFilters) => {
  const res = await privateAxios.get<ConversationSummary[]>(
    `/conversation/list`,
    {
      params: filters,
    }
  );
  return res.data;
};

export const useGetConversationsList = (filters: ConversationListFilters) => {
  return useQuery({
    queryKey: conversationKeys.list(filters),
    queryFn: () => getConversationsList(filters),
  });
};

const getConversation = async (withUserId: string) => {
  const res = await privateAxios.get<Conversation>(
    `/conversation/${withUserId}`
  );

  return res.data;
};

export const useGetConversation = (withUserId: string) => {
  return useQuery({
    queryKey: conversationKeys.detail(withUserId),
    queryFn: () => getConversation(withUserId),
    enabled: !!withUserId,
    placeholderData: (prev) => prev,
  });
};
